import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import CustomSelect from "../CustomComponents/CustomSelect";
import FormHelperText from '@mui/material/FormHelperText';
import moment from "moment";
import { dateTransformation } from '../../utils.js'
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import Tooltip from '@mui/material/Tooltip';
import {logger,checkAuthentication} from '../../utils';
import DialogContentText from "@mui/material/DialogContentText";

export default function EditPoDialog({ refreshTab, data, allProductOrders }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const [LockedAlert, setAlert] = React.useState(false);
    const [alertText, setAlertText] = React.useState("");
    const [productOrders, setProductOrders] = React.useState(allProductOrders);

    const [sowChoices, setSowChoices] = React.useState([
        { label: "testSow 1", value: "test1" },
        { label: "testSow 2", value: "test2" }
    ]);
    
    const [siteChoices, setSiteChoices] = React.useState([
        { label: "testSite1",  value: "test1" },
        { label: "testSite 2", value: "test2" }
    ]);

    const initialValues = {
        SOWID: data.SOWID,
        IsAllProjects: data.IsAllProjects ? true : false,
        poLongName: data.Name,
        poShortName: data.CommonName,
        poNumber: data.PoNumber,
        SoldToID:data.SoldToID,
        ShipToID:data.ShipToID,
        start: moment.utc(data.StartDate).format("MM/DD/YYYY"),
        end: moment.utc(data.EndDate).format("MM/DD/YYYY"),
        owner: data.Owner,
        ownerEmail: data.Email,
        emailGroup: data.EmailGroup,
        Amount: parseFloat(data.Amount).toFixed(2),
        IsBillable: data.IsBillable ? true : false,
        IsActive: data.IsActive ? true : false
    };

    const validFormSchema = Yup.object({
        SOWID: Yup
            .string("Enter an SOWID linked to this PO")
            .required("Linked SOW is required"),
        IsAllProjects: Yup
            .boolean(),
        poLongName: Yup
            .string("Enter a name for the PO")
            .required("Name required"),
        poShortName: Yup
            .string("Enter a common name for the PO")
            .required("Common name required"),
        poNumber: Yup
            .string("Enter a ID number for the PO")
            .required("PO ID required"),
        SoldToID: Yup
            .string("Enter an SoldToID linked to this PO")
            .required("Linked Sold to clientsite name is required"),
        ShipToID: Yup
            .string("Enter an shipToID linked to this PO")
            .required("Linked ship to clientsite name is required"),	    
        start: Yup
            .date("Enter a starting date for the PO dd/mm/yyyy")
            .required("Starting date is required dd/mm/yyyy"),
        end: Yup
            .date("Enter an ending date for the PO dd/mm/yyyy")
            .required("Ending date is required dd/mm/yyyy"),
        owner: Yup
            .string("Enter a name for the PO owner")
            .required("Owner name required"),
        ownerEmail: Yup
            .string("Enter a contact email for PO owner")
            .email("Please use a proper email address")
            .required("An owner email is required"),
        emailGroup: Yup
            .string("Enter a another contact email for PO ")
            .test('Enter a contact email for PO owner', 'Enter a valid email addresses',
            value => value.match(/^(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*,\s*|\s*$))*$/)),
        Amount: Yup.number().test(
            'is-Currency',
            'invalid Currency',
            value => (value.toFixed(2)+"").match(/^[+-]?[0-9]{1,3}(?:[0-9]*(?:[.,][0-9]{2})?|(?:,[0-9]{3})*(?:\.[0-9]{2})?|(?:\.[0-9]{3})*(?:,[0-9]{2})?)$/)
        ),
        IsBillable: Yup
            .boolean(),
        IsActive: Yup
            .boolean()

    })
    
	const handleEditCallback = async(childData) => {
		let response = await fetch("api/PO", {
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				"PO": {
					"ID": childData.ID,
					"SOWID": childData.SOWID,
					"IsAllProjects": childData.IsAllProjects,
					"Name": childData.Name,
					"CommonName": childData.CommonName,
					"PoNumber": childData.PoNumber,
					"SoldToID": childData.SoldToID,
					"ShipToID": childData.ShipToID,
					"StartDate": childData.StartDate,
					"EndDate": childData.EndDate,
					"Owner": childData.Owner,
					"Email": childData.Email,
					"EmailGroup": childData.EmailGroup,
					"Amount": childData.Amount,
					"IsBillable": childData.IsBillable,
					"IsActive": childData.IsActive
				}
			})
		});
		
       if (response.status === 409) {
		   const json = await response.json();
           setAlertText(json.sqlMessage || json.message);
           setAlert(true);
       } else {
           handleClose();
           refreshTab(true);
       }
       
		logger(childData);
		setRefresh(true);
		return response;
	};

    const onTrigger = React.useCallback((values) => {
		console.log("All productOrders=", productOrders);
		var duplicateExists = false;
		for (var i = 0; i < productOrders.length; i++) {
			var eachProductOrder = productOrders[i];
			console.log(eachProductOrder);
			
			if(eachProductOrder.CommonName === values.poShortName){
				console.log(moment.utc(values.start) > moment.utc(eachProductOrder.StartDate));
				console.log(moment.utc(values.end) < moment.utc(eachProductOrder.EndDate));
				
				console.log(moment.utc(values.start) < moment.utc(eachProductOrder.StartDate));
				console.log(moment.utc(values.end) > moment.utc(eachProductOrder.EndDate));
			}
			if (eachProductOrder.PoNumber === values.poNumber && eachProductOrder.ID !== data.ID
				&& ((moment.utc(values.start) >= moment.utc(eachProductOrder.StartDate) && moment.utc(values.start) <= moment.utc(eachProductOrder.EndDate))
					|| (moment.utc(values.end) >= moment.utc(eachProductOrder.StartDate) && moment.utc(values.end) <= moment.utc(eachProductOrder.EndDate))
					|| (moment.utc(values.start) >= moment.utc(eachProductOrder.StartDate) && moment.utc(values.end) <= moment.utc(eachProductOrder.EndDate))
					|| (moment.utc(values.start) <= moment.utc(eachProductOrder.StartDate) && moment.utc(values.end) >= moment.utc(eachProductOrder.StartDate))
					|| (moment.utc(values.end) >= moment.utc(eachProductOrder.StartDate) && moment.utc(values.end) <= moment.utc(eachProductOrder.EndDate)))) {
				duplicateExists = true;
				setAlertText("PO Number :"+ eachProductOrder.PoNumber + " already exists within date range : " + moment.utc(eachProductOrder.StartDate).format('MM-DD-YYYY') + " to " + moment.utc(eachProductOrder.EndDate).format('MM-DD-YYYY'));
				break;
			}
		}
		if (duplicateExists) {
			setAlert(true);
			return;
		}
		
        const msg = {
            ID: data.ID,
            SOWID: values.SOWID,
            IsAllProjects: values.IsAllProjects,
            Name: values.poLongName,
            CommonName: values.poShortName,
            PoNumber: values.poNumber,
            SoldToID: values.SoldToID,
            ShipToID: values.ShipToID,  
            StartDate: moment.utc(values.start),
            EndDate: moment.utc(values.end),
            Owner: values.owner,
            Email: values.ownerEmail,
            EmailGroup: values.emailGroup,
            Amount: parseFloat(values.Amount).toFixed(2),
            IsBillable: values.IsBillable,
            IsActive: values.IsActive
        };
		if ((moment.utc(values.start) > moment.utc(values.end))) {
			setAlertText("Start Date should be before the End Date, Please enter different time period");
			setAlert(true);
		} else {
			handleEditCallback(msg);
		}
    })

    const radioHandler = event => {
        logger(event.target.value)
        setPoType(event.target.value)
    }

    const handleClickOpen = () => {
		setAlertText("");
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    
    const handleAlertClose = () => {
        setAlert(false);
    };


    const setChoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.CommonName, value: choice.ID }))
        setSowChoices(choices)
    }
    
    const setClientSites = (json) => {
		let sites = [];
        json.forEach(site => sites.push({ label: site.Name, value: site.ID }))
        setSiteChoices(sites)
	}

    React.useEffect(() => {
		if (open){
		checkAuthentication();
		}
        if (refresh) {

            fetch('/api/SOW/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setChoices(json));
                
            fetch('/api/client_site', {
				 method: 'Get',
			})
                .then(res => res.json())
                .then(json => setClientSites(json));

            setRefresh(false);
        }
    })

    return (
        <div><MuiThemeProvider theme={muiThemeDesign}>
            <Button variant="contained" onClick={handleClickOpen}>
                Edit
            </Button>
     			<Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                <DialogContent>

                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            PO Edit
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Product Order Info:</DialogTitle>
                                <Grid container spacing={1} pl={1}>
                                    <Grid item xs={6} md={6}>
                                    <div>
                                        <FormControl sx={{ m: 1 }}>
                                            <FormControlLabel
                                                name="IsAllProjects"
                                                label="All Projects"
                                                control={<Checkbox checked={props.values.IsAllProjects} onChange={props.handleChange} />}
                                            />
                                        </FormControl>
                                    </div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <InputLabel htmlFor="outlined-SOWID">Linked SOW</InputLabel>
                                        <CustomSelect
                                            name="SOWID"
                                            id="outlined-SOWID"
                                            options={sowChoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.SOWID}
                                            error={props.touched.SOWID && Boolean(props.errors.SOWID)}
                                            helperText={props.touched.SOWID && props.errors.SOWID}
                                            label="Linked SOW"
                                        />
                                    </FormControl>
                                    
                                      
                               
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="poNumber"
                                            id="outlined-PoNumber"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.poNumber}
                                            error={props.touched.poNumber && Boolean(props.errors.poNumber)}
                                            helperText={props.touched.poNumber && props.errors.poNumber}
                                            label="PO number"
                                        />
                                    </FormControl>
                                        </div>
                                        <div>
                                            <FormControl sx={{ m: 1, width: 160 }}>
                                                <TextField
                                                    name="Amount"
                                                    id="outlined-Amount"
                                                    onChange={props.handleChange}
                                                    onBlur={props.handleBlur}
                                                    value={props.values.Amount}
                                                    error={props.touched.Amount && Boolean(props.errors.Amount)}
                                                    helperText={props.touched.Amount && props.errors.Amount}
                                                    label="Amount"
                                                />
                                            </FormControl>
                                        </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="poLongName"
                                            id="outlined-PoLongName"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.poLongName}
                                            error={props.touched.poLongName && Boolean(props.errors.poLongName)}
                                            helperText={props.touched.poLongName && props.errors.poLongName}
                                            label="PO Long Name"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="poShortName"
                                            id="outlined-PoShortName"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.poShortName}
                                            error={props.touched.poShortName && Boolean(props.errors.poShortName)}
                                            helperText={props.touched.poShortName && props.errors.poShortName}
                                            label="PO Short Name"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 160 }}>
                                        <TextField
                                            name="start"
                                            id="outlined-Start"
                                            type= "date"
                                            value={props.values.start.indexOf("/")>0?dateTransformation(props.values.start):props.values.start}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            error={props.touched.name && Boolean(props.errors.start)}
                                            helperText={props.touched.start && props.errors.start}
                                            label="Start"
                                            InputLabelProps={{
												shrink: true,
											}}

                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 160 }}>
                                        <TextField
                                            name="end"
                                            id="outlined-End"
                                            type= "date"
                                             value={props.values.end.indexOf("/")>0?dateTransformation(props.values.end):props.values.end}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            error={props.touched.end && Boolean(props.errors.end)}
                                            helperText={props.touched.end && props.errors.end}
                                            label="End"
                                            InputLabelProps={{
												shrink: true,
											}}
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="IsBillable"
                                            label="Billable"
                                            control={<Checkbox checked={props.values.IsBillable} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="IsActive"
                                            label="Active"
                                            control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4} md={4} sx={{ border: '1px solid gray' }}>
                                        <Typography sx={{ ml: 2, flex: 1, color: "primary", align: "center" }} variant="caption" component="div" >
                                            Client/Billing Details
                                        </Typography>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="owner"
                                            id="outlined-Owner"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.owner}
                                            error={props.touched.owner && Boolean(props.errors.owner)}
                                            helperText={props.touched.owner && props.errors.owner}
                                            label="Owner"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 270 }}>
                                        <TextField
                                            name="ownerEmail"
                                            id="outlined-OwnerEmail"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.ownerEmail}
                                            error={props.touched.ownerEmail && Boolean(props.errors.ownerEmail)}
                                            helperText={props.touched.ownerEmail && props.errors.ownerEmail}
                                            label="Owner Email"
                                        />
                                            </FormControl>
                                            <FormControl sx={{ m: 1, width: 240 }}>
                                                <InputLabel htmlFor="outlined-SoldClientSiteName">Bill to Client Site</InputLabel>
                                                <CustomSelect
                                                    name="SoldToID"
                                                    id="outlined-SoldClientSiteName"
                                                    options={siteChoices}
                                                    onChange={props.handleChange}
                                                    onBlur={props.handleBlur}
                                                    value={props.values.SoldToID}
                                                    error={props.touched.SoldToID && !Boolean(props.values.SoldToID)}
                                                    helperText={props.touched.SoldToID && props.errors.SoldToID}
                                                    label="Sold to Client Name"
                                                />
                                                {props.touched.SoldToID && !Boolean(props.values.SoldToID) &&
													<FormHelperText error={true}>Linked Bill to clientsite name is required</FormHelperText>}
                                            </FormControl>

                                            <FormControl sx={{ m: 1, width: 240 }}>
                                                <InputLabel htmlFor="outlined-ShipClientSiteName">Ship to Client Site</InputLabel>
                                                <CustomSelect
                                                    name="ShipToID"
                                                    id="outlined-ShipClientSiteName"
                                                    options={siteChoices}
                                                    onChange={props.handleChange}
                                                    onBlur={props.handleBlur}
                                                    value={props.values.ShipToID}
                                                    error={props.touched.ShipToID && !Boolean(props.values.ShipToID)}
                                                    helperText={props.touched.ShipToID && props.errors.ShipToID}
                                                    label="Ship to Client Name"
                                                />
                                                {props.touched.ShipToID && !Boolean(props.values.ShipToID) &&
													<FormHelperText error={true}>Linked ship to clientsite name is required</FormHelperText>}
                                            </FormControl>
                                     <FormControl sx={{ m: 1, width: 270 }}>
                                    <Tooltip title="Seperate each Email Address by a comma" placement="top">
                                        <TextField
                                            name="emailGroup"
                                            id="outlined-EmailGroup"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            multiline
                                            rows={6}
                                            value={props.values.emailGroup}
                                            error={Boolean(props.errors.emailGroup)}
                                            helperText={props.errors.emailGroup}
                                            label="Email Group"
                                        />
                                    </Tooltip>
                                    </FormControl>
                                </div>
                               </Grid>
                              </Grid> 
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
                <Dialog
                    open={LockedAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="Date Alert"
                    aria-describedby="Start Date before the End Date"
                >
                    <DialogTitle id="Date Alert">
                        {"Alert"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {alertText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                    </DialogActions>
                </Dialog>   
            </Dialog></MuiThemeProvider>
        </div>
    );
}